// This file is auto-generated by @hey-api/openapi-ts

export type ArticlesListResponse = {
    count: number;
    next: (string) | null;
    previous: (string) | null;
    results: Array<ArticleListItem>;
};

export type ArticleListItem = {
    id: number;
    type: string;
    slug: string;
    is_ugc: boolean;
    main_photo: ArticleMainPhoto;
    title: string;
    intro: string;
    tagline: string;
    url: string;
    geo: ArticleGeo;
    reading_time: number;
    created_at: Date;
    updated_at: Date;
    published_at: Date;
};

export type ArticleMainPhoto = {
    lightbox: string;
    scaled: string;
    thumbnail: string;
    thumbnail_s: string;
    thumbnail_m: string;
    thumbnail_l: string;
    thumbnail_xl: string;
};

export type ArticleGeo = {
    region: Array<ArticleGeoItem>;
    country: Array<ArticleGeoItem>;
    city: Array<ArticleGeoItem>;
};

export type ArticleGeoItem = {
    id?: number;
    name?: string;
    slug?: string;
    url?: string;
    [key: string]: unknown | number | string;
};

export type GetArticlesListData = {
    query?: {
        /**
         * ID автора для фильтрации
         */
        author_id?: number;
        /**
         * ID города для фильтрации
         */
        city_id?: number;
        /**
         * Slug города для фильтрации
         */
        city_slug?: string;
        /**
         * Slug страны для фильтрации
         */
        country_slug?: string;
        /**
         * ID экскурсии для фильтрации
         */
        experience_id?: number;
        /**
         * Список id через запятую
         */
        ids?: string;
        /**
         * Фильтр по UGC статьям
         */
        is_ugc?: boolean;
        /**
         * Сортировка
         */
        ordering?: 'pageviews_sorting' | '-pageviews_sorting' | 'ga_pageviews_recent' | '-ga_pageviews_recent' | 'published_at' | '-published_at' | 'geo' | 'filter_slugs';
        /**
         * Номер страницы
         */
        page?: number;
        /**
         * Размер страницы
         */
        page_size?: number;
        /**
         * Показывать статьи, опубликованные после указанной даты
         */
        published_after?: Date;
        /**
         * ID региона для фильтрации
         */
        region_id?: number;
        /**
         * Slug региона для фильтрации
         */
        region_slug?: string;
        /**
         * Список slug через запятую
         */
        slugs?: string;
        /**
         * ID тега для фильтрации
         */
        tag_id?: number;
        /**
         * Тип статьи
         */
        type?: 'article' | 'sight';
    };
};

export type GetArticlesListResponse = (ArticlesListResponse);

export type GetArticlesListError = unknown;

export type GetArticlesListResponseTransformer = (data: any) => Promise<GetArticlesListResponse>;

export type ArticlesListResponseModelResponseTransformer = (data: any) => ArticlesListResponse;

export type ArticleListItemModelResponseTransformer = (data: any) => ArticleListItem;

export const ArticleListItemModelResponseTransformer: ArticleListItemModelResponseTransformer = data => {
    if (data?.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data?.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    if (data?.published_at) {
        data.published_at = new Date(data.published_at);
    }
    return data;
};

export const ArticlesListResponseModelResponseTransformer: ArticlesListResponseModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ArticleListItemModelResponseTransformer);
    }
    return data;
};

export const GetArticlesListResponseTransformer: GetArticlesListResponseTransformer = async (data) => {
    ArticlesListResponseModelResponseTransformer(data);
    return data;
};